<template>
  <v-dialog
    v-bind="$attrs"
    v-on="$listeners"
    max-width="564"
  >
    <v-card>
      <v-card-title>
        <h2
          :class="[
            { [$style.titleCentered]: center_title },
            'text-h2'
          ]"
        >
          <slot name="title" />
        </h2>
      </v-card-title>
      <v-card-text
        :class="[
          { [$style.textCentered]: center_text },
          'text-body-1'
        ]"
      >
        <slot name="text" />
      </v-card-text>
      <v-card-actions :class="[$style.modalButtons, $style.center]">
        <v-btn
          :class="$style.closeSuccessDialog"
          depressed
          color="accent darken-4"
          @click="close"
        >
          <slot name="btn-text">
            Продолжить
          </slot>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import {
  Component,
  Emit,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class SuccessDialog extends Vue {
  @Prop({ type: Boolean, default: false })
  center_title!: boolean;

  @Prop({ type: Boolean, default: false })
  center_text!: boolean;

  @Emit()
  close() {
    return false;
  }
}
</script>

<style module lang="scss">
@import '../common.scss';

.titleCentered {
  margin-left: auto;
  margin-right: auto;
}

.textCentered {
  text-align: center;
}
</style>
